import { createRichTextResolver } from '#layers/storyblok/app/utils/resolver-utils'

export const paragraph = createRichTextResolver(({ children }, props) => h(resolveComponent('u-text'), props, () => children), {
  tag: 'p',
  class: '[&:not(:last-child)]:mb-6',
})

export const ulList = createRichTextResolver(({ children }, props) => h(resolveComponent('u-text'), props, () => children), {
  tag: 'ul',
  class: 'list-disc [&:not(:last-child)]:mb-6',
})

export const olList = createRichTextResolver(({ children }, props) => h(resolveComponent('u-text'), props, () => children), {
  tag: 'ol',
  class: 'list-decimal [&:not(:last-child)]:mb-6',
})

export const listItem = createRichTextResolver(({ children }, props) => h(resolveComponent('u-text'), props, () => children), {
  tag: 'li',
  class: 'ms-6',
})

export const blockquotes = createRichTextResolver(({ children }, props) => h(resolveComponent('u-text'), props, () => children), {
  tag: 'blockquotes',
  color: 'type-interactive',
  class: 'p-6 block sm:px-10 sm:py-8 rounded-6 bg-[rgba(var(--v-theme-type-interactive),.12)]',
})

export const heading = createRichTextResolver(({ children, attrs }, props) => {
  const {
    class: _class,
    ...restProps
  } = props || {}
  const level = attrs?.level as string
  const tag = `h${level}`
  const classes = {
    1: '',
    2: 'text-18 sm:text-22 lg:text-36 font-galano',
    3: 'text-18 sm:text-22 lg:text-28',
    4: 'text-16 sm:text-22 lg:text-22',
    5: 'text-14',
    6: 'text-12',
  }[level]

  return h(resolveComponent('u-text'), {
    tag,
    color: '#27292E',
    class: [
      'font-bold',
      classes,
      _class,
    ],
    ...restProps,
  }, () => children)
}, {
  class: '[&:not(:last-child)]:mb-6',
})
